/** Title-cases a raw stage code (e.g. SAMPLE_SELECT → "Sample Select") for fallback labels. */
export function formatStageCode(code: string): string {
  return code
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
